import { theme } from 'Ui';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';

type LinkCustom = {
  to?: string;
  internal?: boolean;
  children?: React.ReactNode;
  onClick?: any;
  style?: any;
  activeStyle?: any;
  activeClassName?: string;
  target?: string;
  dataTest?: string;
  underlinecolor?: string;
};

export const Link = ({
  to,
  internal,
  children,
  onClick,
  activeStyle,
  target,
  dataTest,
}: LinkCustom) => {
  if (internal)
    return (
      <NavLink
        to={to || ''}
        onClick={onClick}
        target={target}
        data-test={dataTest}
        // style={({ isActive }) => (isActive ? activeStyle : '')}
      >
        {children}
      </NavLink>
    );
  else
    return (
      <a target={target} href={to}>
        {children}
      </a>
    );
};

const MenuLink = styled(NavLink)<{ underlinecolor?: string }>`
  font-size: 1.6rem;
  display: flex;
  white-space: nowrap;
  align-items: center;
  text-transform: uppercase;
  font-family: var(--font-primary);
  padding-right: 1.5rem;
  padding: 0.5rem 0.8rem 0rem;
  /* height: 7.5rem; */
  justify-content: center;
  cursor: pointer;
  margin: 0 0.5rem;
  flex-direction: column;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0.5px;
  vertical-align: middle;
  :hover {
    /* color: var(--design-text-color); */
    font-weight: 400;
  }
  :after {
    content: '';
    display: flex;
    width: 0;
    height: 3px;
    transition: 0.3s;
    margin: 0;
    margin-top: 4px;
  }
  &:hover::after {
    width: 100%;
    margin-left: 0;
    transition: width 0.3s;
    background: ${({ underlinecolor }) =>
      underlinecolor ? `${underlinecolor}` : `var(--design-base-color)`};
  }
  &.no-underline {
    :after {
      content: none;
    }
  }
  &.active {
    color: ${theme.light.colors.black};
    font-weight: 600;
  }
  &.active:after {
    content: '';
    display: flex;
    width: 100%;
    height: 3px;
    background: ${({ underlinecolor }) =>
      underlinecolor ? `${underlinecolor}` : `var(--design-base-color)`};
    transition: 0.3s;
    margin: 0;
    margin-top: 4px;
  }
  @media screen and (max-width: ${theme.breakpoints.small}px) {
    height: auto;
  }
  @media screen and (min-width: ${theme.breakpoints.small}px) {
    padding-right: 0;
    font-weight: 500;
    padding: 0.5rem 0rem 0rem;
    cursor: pointer;
    margin: 0 0rem;
  }
`;

const MenuHref = styled.a<{ underlinecolor?: string }>`
  font-size: 1.6rem;
  display: flex;
  white-space: nowrap;
  align-items: center;
  text-transform: uppercase;
  font-family: var(--font-primary);
  padding-right: 1.5rem;
  padding: 0.5rem 0.8rem 0rem;
  /* height: 7.5rem; */
  justify-content: center;
  cursor: pointer;
  margin: 0 0.5rem;
  flex-direction: column;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 0.5px;
  vertical-align: middle;
  :hover {
    color: var(--design-base-color);
    font-weight: 400;
  }
  :after {
    content: '';
    display: flex;
    width: 0;
    height: 3px;
    transition: 0.3s;
    margin: 0;
    margin-top: 4px;
  }
  &:hover::after {
    width: 100%;
    background: ${({ underlinecolor }) =>
      underlinecolor ? `${underlinecolor}` : `var(--design-base-color)`};
    margin-left: 0;
    transition: width 0.3s;
    color: var(--design-base-color);
  }
  &.no-underline {
    :after {
      content: none;
    }
  }
  &.active {
    color: var(--design-base-color);
    font-weight: 600;
  }
  &.active:after {
    content: '';
    display: flex;
    width: 100%;
    height: 3px;
    background: ${({ underlinecolor }) =>
      underlinecolor ? `${underlinecolor}` : `var(--design-base-color)`};
    transition: 0.3s;
    margin: 0;
    margin-top: 4px;
  }
  @media screen and (max-width: ${theme.breakpoints.small}px) {
    height: auto;
  }
  @media screen and (min-width: ${theme.breakpoints.small}px) {
    padding-right: 0;
    font-weight: 500;
    padding: 0.5rem 0rem 0rem;
    cursor: pointer;
    margin: 0 0rem;
  }
`;

export const HeaderLinks = ({
  to,
  internal,
  children,
  onClick,
  style,
  dataTest,
  underlinecolor,
}: LinkCustom) => {
  if (internal)
    return (
      <MenuLink
        data-test={dataTest}
        underlinecolor={underlinecolor}
        to={to || ''}
        onClick={onClick}
        style={style}
      >
        {children}
      </MenuLink>
    );
  else
    return (
      <MenuHref underlinecolor={underlinecolor} style={style} href={to}>
        {children}
      </MenuHref>
    );
};
